import { Component, CUSTOM_ELEMENTS_SCHEMA, NgModule, ViewChild } from '@angular/core';
import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';
import { environment } from 'src/environments/environment';
import { DownloadService } from '../../services/download/download.service';
import { BaseService } from '../../services/base/base.service';
import { BentoAlertItemOptions } from '@bento/bento-ng';
import { BackendTokenClaims } from '../../models/tokenResponse';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import {Role} from 'src/app/shared/enums';
import { HeadersFocusability } from '@grapecity/wijmo.grid';

@Component({
  selector: 'app-exported-views',
  templateUrl: './exported-views.component.html',
  styleUrls: ['./exported-views.component.scss']
})
export class ExportedViewsComponent {

  @ViewChild('flexGrid', { static: true }) flexGrid: wjcGrid.FlexGrid;
  data: wjcCore.CollectionView;
  pageInfo: any = {
    infoText: '_START_ to _END_ of _MAX_ Users',
    infoPageText: '_PAGE_ of _PAGES_',
    goText: 'Go',
    pageSize: 10,
  };
  alerts: BentoAlertItemOptions[] = [];
  errorMessage: any;
  gridsSelectedRow = 0;
  gridsSelectedCol = 0;
  lastPressedKey: any;
  filteredReportData = [];
  searchText = '';
  isGetDataLoading = false;
  reportDataList: any = [];
  headersFocusability = HeadersFocusability.All;
  sortDirection = '';
  isExportNameAscending: boolean | null = null;
  isExportDateAscending: boolean | null = null;
  isPendingAscending: boolean | null = null;

  constructor(
    private downloadFile: DownloadService,
    private _service: BaseService,
    private authService: AuthService
  ) {
    this.init();
  }

  async init() {
    this.getGridData();
  }


  gridInitialized(flexGrid) {
    if (flexGrid.rows) {
      flexGrid.rows.defaultSize = 35;
      flexGrid.columnHeaders.rows.defaultSize = 40;
      flexGrid.hostElement.addEventListener('keydown', (e) => {
        this.lastPressedKey = e.code;
      });

      this.flexGrid = flexGrid;
    }
  }

  public get isTAdmin(): boolean {
    const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
    return backendTokenClaims && backendTokenClaims.userDDO && backendTokenClaims.userDDO.role === Role.TAdmin;
  }

  reportDownload(reportName) {
    var extension = 'xlsx';

    let newReportName,
      downloadFirmID,
      firmId;

    newReportName = reportName.split('_');
    downloadFirmID = newReportName[2];

    firmId = this.isTAdmin  ? downloadFirmID : this.getfirmId;

    //this._service.downloadExcel(environment.FIAdminBaseEndpoint + 'v1/async/export/downloadFile/firmId/'+ this.getfirmId +'?fileName=' + reportName).subscribe(
    this._service.downloadExcel(environment.FIAdminBaseEndpoint + 'v1/async/export/downloadFile/firmId/' + firmId + '?fileName=' + reportName).subscribe(
      (response) => {
        this.downloadFile.downloadWithExtension(
          response.body,
          response.headers.get('content-disposition').split('=')[1],
          extension
        );
      },
      (error) => {
        this.errorMessage = error.error;
        this.alerts.push({
          type: 'warning',
          msg: 'Something went wrong, please try again.',
          timeout: 2500,
          closeable: true,
        });
      }
    );
  }
  handleSelectionChanged(sender: wjcGrid.FlexGrid, args: wjcGrid.CellRangeEventArgs) {
    this.gridsSelectedCol = args.col;
    this.gridsSelectedRow = args.row;
    // if (this.lastPressedKey == 'ArrowDown' || this.lastPressedKey == 'ArrowUp') {
    //   let selectedCell = args.panel.getCellElement(args.row, args.col);
    //   if (selectedCell) {
    //     const windowHeight = window.innerHeight;
    //     const documentHeight = document.body.scrollHeight;
    //     const scrollTop = (documentHeight - windowHeight) / 2;
    //     window.scrollTo({
    //       top: scrollTop + 56,
    //       behavior: 'smooth',
    //     });
    //   }
    // }
  }

  handleKeyDown(flexGrid: wjcGrid.FlexGrid, e: KeyboardEvent) {
    const target = e.target as HTMLElement;
    const isHeader = target.closest('.wj-header') !== null;

    if (e.code === 'Tab' && !e.shiftKey && isHeader) {
      e.preventDefault();
    const gridElement = flexGrid.hostElement;
    const allInteractiveElements = Array.from(
      gridElement.closest('app-peer-check')?.querySelectorAll<HTMLElement>(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ) || []
    );
     let nextElement: HTMLElement | null = null; 
      const outsideGridElements = allInteractiveElements.filter(el => !gridElement.contains(el));
       nextElement = null;
      for (const el of outsideGridElements) {
        if (
          ((el.tagName === 'BUTTON' && !(el as HTMLButtonElement).disabled) ||
          (el.classList.contains('form-control') && !(el as HTMLInputElement).disabled && !(el as HTMLInputElement).readOnly)) &&
          (el.compareDocumentPosition(gridElement) & Node.DOCUMENT_POSITION_PRECEDING)
        ) {
          nextElement = el;
          break;
        }
      }
      if (!nextElement && outsideGridElements.length > 0) {
        nextElement = outsideGridElements[0];
      }
      nextElement?.focus();
    }

    if (e.code === 'Space') {
      e.preventDefault();

      if (this.gridsSelectedCol === 3 && !isHeader) {
        let cell = flexGrid.cells.getCellElement(this.gridsSelectedRow, this.gridsSelectedCol);
        let input = cell?.querySelector('input');
        input?.click();
      }
    }
  } 

  sortGrid(headerName: string, headerText: string) {
    if (headerName === 'exportName') {
      this.isExportDateAscending = null;
      this.isPendingAscending = null;
      this.isExportNameAscending = this.isExportNameAscending === null ? true : !this.isExportNameAscending;
      this.setOrderBy(headerName, this.isExportNameAscending);
    }
    else if (headerName === 'requestModifiedDate') {
      this.isExportNameAscending = null;
      this.isPendingAscending = null;
      this.isExportDateAscending = this.isExportDateAscending === null ? true : !this.isExportDateAscending;
      this.setOrderBy(headerName, this.isExportDateAscending);
    }
    else  {
      this.isExportNameAscending = null;
      this.isExportDateAscending = null;
      this.isPendingAscending = this.isPendingAscending === null ? true : !this.isPendingAscending;
      this.setOrderBy(headerName as 'status' | 'action', this.isPendingAscending);
    }

    const liveRegion = document.getElementById('liveRegion');
    if (liveRegion) {
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = headerText + ", column header, button sortable, " + this.sortDirection;
      }, 10);
    }    
  }

  setOrderBy(header: 'exportName' | 'requestModifiedDate' | 'status'|'action', isAscending: boolean | null) {
    this.sortDirection = isAscending ? 'ascending' : 'descending';
  }

  onPageSizeChanged(size) {
    this.data.pageSize = size;
    this.flexGrid.select(this.flexGrid.rows.length - 1, this.flexGrid.columns.length - 1);
    //this.tkHistoryRecordRequest.size = size;
    this.pageInfo.pageSize = size;
  }

  // Pagination Page Changed Event Handler
  onPageChanged(page) {
    this.data.moveToPage(page - 1);
  }
  getReportDataList() {
    this.isGetDataLoading = true;
    this._service.get(environment.FIAdminBaseEndpoint + 'v1/async/export/reports/firm/' + this.getfirmId, '').subscribe(
      (result) => {
        this.reportDataList = result;
        this.data = new wjcCore.CollectionView(this.reportDataList);
        this.data.pageSize = this.pageInfo.pageSize;
        this.isGetDataLoading = false;
      },
      (error) => {
        this.errorMessage = error.error;
        this.alerts.push({
          type: 'warning',
          msg: this.errorMessage,
          timeout: 2500,
          closeable: true,
        });
        this.isGetDataLoading = false;
      }
    );
  }
  private get getfirmId(): number {
    const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
    return backendTokenClaims.userDDO
      ? backendTokenClaims.userDDO.firmID : null
  }
  refreshData() {
    this.getGridData();
  }
  getGridData() {
    this.isGetDataLoading = true;
    this.getReportDataList();
    this.data = new wjcCore.CollectionView(this.reportDataList);
    this.data.pageSize = this.pageInfo.pageSize;
  }

}
